module.exports = __webpack_public_path__ + "static/media/DesignBg.f5763825.png";